import { useContext, useEffect, useState } from "react";
import Login from "./pages/login/Login";
import {
    createBrowserRouter,
    RouterProvider,
    Outlet, Route,
} from "react-router-dom";
import '@ant-design/v5-patch-for-react-19';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Layout } from 'antd';
import { AuthContext } from "./shared/contexts/authContext";
import { applyEnvTheme } from "./shared/utils/enum";
import { DarkModeContext } from "./shared/contexts/darkModeContext";
import { SocketProvider } from "./shared/contexts/SocketContext";

import { children } from "./routes";
import Register from "./pages/register/Register";
import { ProtectedRoute } from "./routes/ProtectedRoute";
import PasswordRecovery from "./pages/passwordRecovery/PasswordRecovery";
import "./layout.scss";
import socketService from "./shared/services/SocketService";
import SideBar from "./layout/SideBar";
import HeaderBar from "./layout/HeaderBar";
import Auth from "./pages/analytics/Auth";
import Analytics from "./pages/analytics/Analytics";


const { Content } = Layout;
const queryClient = new QueryClient();

const MainLayout = () => {
    const { darkMode } = useContext(DarkModeContext);
    const { currentUser } = useContext(AuthContext);
    const [collapsed, setCollapsed] = useState(false);

    // 접속 서버(develop/qa/production)별 테마 색상
    useEffect(() => {
        applyEnvTheme(currentUser?.target);
    }, [currentUser?.target]);

    // collapsed 상태에 따른 동적 스타일 계산 - 폭 조정
    const sideWidth = collapsed ? 80 : 260;

    return (
        <Layout className={`main-layout ${darkMode ? 'dark-theme' : 'light-theme'}`} style={{ minHeight: '100vh' }}>
            <SideBar
                collapsed={collapsed}
            />

            <Layout style={{ marginLeft: sideWidth, transition: 'margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1)' }}>
                <HeaderBar
                    collapsed={collapsed}
                    setCollapsed={setCollapsed}
                    sideWidth={sideWidth}
                />

                {/* 콘텐츠 영역 */}
                <Content className="layout-content">
                    <div className="content-wrapper">
                        <Outlet />
                    </div>
                </Content>
            </Layout>
        </Layout>
    );
};

const router = createBrowserRouter([
    {
        path: "/",
        element: (
            <ProtectedRoute>
                <MainLayout />
            </ProtectedRoute>
        ),
        children,
    },
    {
        path: "/login",
        element: <Login />,
    },
    {
        path: "/register",
        element: <Register />,
    },
    {
        path: "/password-recovery",
        element: <PasswordRecovery />,
    },
    {
        path: "/analytics",
        element: <Analytics />,
    },
    {
        path: "/analytics/auth",
        element: <Auth />,
    },
]);

function App() {
    const { currentUser } = useContext(AuthContext);

    // 특정 도메인에서만 title, favicon 변경
    useEffect(() => {
        if (window.location.hostname === process.env.REACT_APP_SOCKET_URL) {
            document.title = "ACT Games - Hello Kitty My Dream Store";
            let link = document.querySelector("link[rel~='icon']");
            if (!link) {
                link = document.createElement('link');
                link.rel = 'icon';
                document.head.appendChild(link);
            }
            link.href = "/UI/Images/Merge/MergeBlock/501.png";
            link.type = "image/png";
        }
    }, []);

    // useEffect(() => {
    //     // 사용자가 로그인 상태일 때 소켓 연결
    //     if (currentUser && !socketService.isSocketConnected()) {
    //         console.log('Attempting to connect socket...');
    //         socketService.connect();
    //     }
    //
    //     // 컴포넌트가 언마운트되거나 사용자가 로그아웃할 때 연결 해제
    //     return () => {
    //         if (socketService.isSocketConnected()) {
    //             console.log('Disconnecting socket on cleanup...');
    //             socketService.disconnect();
    //         }
    //     };
    // }, [currentUser]); // currentUser가 변경될 때마다 실행

    return (
        <div>
            <QueryClientProvider client={queryClient}>
                <SocketProvider>
                    <RouterProvider router={router} />
                </SocketProvider>
            </QueryClientProvider>
        </div>
    );
}

export default App;